/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './mythsandfacts.css';
import parse from 'html-react-parser';

function MythsAndFacts({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;

  const {
    title,
    description,
    myths
  } = data;

  // Safe parse function to handle undefined or null content
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };

  return (
    <div className="myth-and-facts-section">
      <Container>
        {/* Title Section */}
        {title && 
          <h2 className="myth-facts-title">
            {safeParse(title)}
          </h2>
        }
        
        {/* Description */}
        {description && 
          <div className="myth-facts-description">
            <p>{safeParse(description)}</p>
          </div>
        }

        {/* Myths */}
        {myths && myths.length > 0 && (
          <Row className="myths-container">
            {myths.map((myth, index) => (
              <Col md={6} key={index} className="myth-item-col">
                <div className="myth-item">
                  <p className="myth-text">
                    {safeParse(myth.text)}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
}

export default MythsAndFacts;